import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';

domReady(() => {
  const newsCarousels = document.querySelectorAll('.related-posts');

  if (0 < newsCarousels.length) {
    newsCarousels.forEach((newsCarousel) => {
      new Swiper(newsCarousel.querySelector('.related-posts__carousel'), {
        slidesPerView: 1.2,
        spaceBetween: 10,

        breakpoints: {
          600: {
            slidesPerView: 1.9,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2.4,
            spaceBetween: 30,
          },
          1200: {
            slidesPerView: 3.13,
            spaceBetween: 30,
          },
        },

        navigation: {
          prevEl: newsCarousel.querySelector('.swiper-button-prev'),
          nextEl: newsCarousel.querySelector('.swiper-button-next'),
        },
      });
    });
  }
});
